import { useRuntimeConfig } from 'virtual:runtime-config';

import { makeSingleton } from '@/shared/utils/makeSingleton';

import { MF_NAME } from './env';
import { initRuntimeConfigExtends, type RuntimeConfigBase } from './runtimeExtends';

/** Инициализирует обязательные runtime-поля и задаёт безопасные значения по умолчанию. */
const initRuntimeConfig = (): RuntimeConfigBase => {
  const namespace = useRuntimeConfig<Partial<RuntimeConfigBase>>()[MF_NAME];
  const soguUrl = namespace?.VITE_RUNTIME_SOGU_SERVICE_URL;

  if (!soguUrl) {
    throw new Error('Missing runtime config field: VITE_RUNTIME_SOGU_SERVICE_URL');
  }

  return initRuntimeConfigExtends({
    ...namespace,
    VITE_RUNTIME_SOGU_SERVICE_URL: soguUrl,
    VITE_RUNTIME_SENTRY_DSN: namespace?.VITE_RUNTIME_SENTRY_DSN ?? '',
    VITE_RUNTIME_CANONICAL_URL: namespace?.VITE_RUNTIME_CANONICAL_URL ?? 'https://experience.tripster.ru',
  });
};

const runtimeSingleton = makeSingleton(initRuntimeConfig);

/** Возвращает runtime-конфиг, созданный единожды на экземпляр MFE. */
export const getRuntimeConfig = runtimeSingleton.getInstance;
